export const PERMISSION_LOADING = "PERMISSION_LOADING";
export const PERMISSION_LOADED = "PERMISSION_LOADED";

export const GET_ALL_PERMISSIONS = "GET_ALL_PERMISSIONS";
export const GET_COMMUNITY_PERMISSIONS = "GET_COMMUNITY_PERMISSIONS";